import { render, staticRenderFns } from "./HeaderPayment.vue?vue&type=template&id=364e0777&"
import script from "./HeaderPayment.vue?vue&type=script&lang=js&"
export * from "./HeaderPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports